const loadCtaAfterSubmissionFormData = require("../src/run/ctaAfterSubmission/loadCtaAfterSubmissionFormData");
const saveCtaAfterSubmissionFormData = require("../src/run/ctaAfterSubmission/saveCtaAfterSubmissionFormData");

class CtaAfterSubmission {
    loadFormData() {
        return loadCtaAfterSubmissionFormData();
    }

    saveFormData(formData) {
        saveCtaAfterSubmissionFormData(formData);
    }
}

if (!('ITERABLE_MODULES' in window)) {
    window.ITERABLE_MODULES = {};
}
window.ITERABLE_MODULES.CtaAfterSubmission = CtaAfterSubmission;

module.exports = CtaAfterSubmission;
